// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// LinkText
import MsaModeInput from 'components/inputs/MsaModeInput';
import LinkText from 'components/text/LinkText';
import StatesInput from 'components/inputs/StatesInput';
import MsaSearchInput from 'components/inputs/MsaSearchInput';
import Button from 'components/common/Button';
import Tag from 'components/common/Tag';
import Form from 'components/common/Form';
import FormItem from 'components/common/FormItem';
import constants from 'lib/constants';
import Alert from 'components/common/Alert';
import message from 'antd/lib/message';
// APOLLO
import editMsas from 'ApolloClient/Mutations/editMsas';
import { graphql, compose } from 'react-apollo';

const FormSection = styled.div`
  padding: ${p => p.theme.padding}px;
  display: flex;
  align-items: center;
`;

class MsaForm extends React.PureComponent {
  state = {
    allowedStates: this.props.allowedStates,
    allowedMSAs: this.props.allowedMSAs,
    msaMode: this.props.msaMode,
  };

  onChange = newValue => {
    this.setState(newValue);
  };
  getValues = () => ({
    allowedStates: this.state.allowedStates,
    allowedMSAs: this.state.allowedMSAs.map(msa => msa.msaName),
    msaMode: this.state.msaMode,
  });

  onSubmit = () => {
    let values = this.getValues();
    this.props.handleSubmit(values);
  };

  onRemoveMSA = async msaToRemove => {
    message.success(`time to remove ${msaToRemove.msaName}`);
    let filtered = this.state.allowedMSAs.filter(msa => msa._id !== msaToRemove._id)
    console.log({
      current: this.state.allowedMSAs,
      filtered,
    });
    this.setState({
      allowedMSAs: filtered,
    });
    // let values = this.getValues();
    // let variables = {
    //   orgId: this.props.organization._id,
    //   params: {
    //     ...values,
    //     allowedMSAs: this.state.allowedMSAs.filter(msa => msa._id === msaToRemove._id).map(msa => msa.msaName),
    //   },
    // };

    // try {
    //   await this.props.editMsas({ variables });
    // } catch (err) {
    //   return console.log(err);
    // }
  };
  onClearAllStates = () => {
    this.setState({
      allowedStates: []
    });
  }
  onClearAllMSAs = async () => {
    this.setState({
      allowedMSAs: []
    });
    // let values = this.getValues();
    // let variables = {
    //   orgId: this.props.organization._id,
    //   params: {
    //     ...values,
    //     allowedMSAs: [],
    //   },
    // };

    // try {
    //   await this.props.editMsas({ variables });
    // } catch (err) {
    //   return console.log(err);
    // }
  };
  uniqEs6 = (arrArg) => {
    return arrArg.filter((elem, pos, arr) => {
      return arr.indexOf(elem) == pos;
    });
  }
  onHandleStatesChange = newState => {
    if (newState === 'All States') {
      return this.onChange({
        allowedStates: constants.statesData.filter(item => item.name !== 'All States').map(item => item.abbreviation),
      });
    }
    this.onChange({ allowedStates: [...this.state.allowedStates, newState] });
  };

  render() {
    return (
      <Form>
        {this.state.allowedMSAs && this.state.allowedMSAs.length > 0 && (
          <Alert
            message="To change mode from by-state to by-msa, please clear all selected msa/states first."
            type="info"
            closable
          />
        )}
          {this.state.msaMode === 'msa' && (!this.state.allowedMSAs || this.state.allowedMSAs.length === 0) && (
            <FormSection>
              <FormItem label="Mode">
                <MsaModeInput
                  disabled={this.state.allowedMSAs && this.state.allowedMSAs.length > 0}
                  value={this.state.msaMode}
                  onChange={msaMode => this.onChange({ msaMode })}
                />{' '}
              </FormItem>
            </FormSection>
          )}
          {this.state.msaMode === 'state' && (!this.state.allowedStates || this.state.allowedStates.length === 0) && (
            <FormSection>
              <FormItem label="Mode">
                <MsaModeInput
                  disabled={this.state.allowedStates && this.state.allowedStates.length > 0}
                  value={this.state.msaMode}
                  onChange={msaMode => this.onChange({ msaMode })}
                />{' '}
              </FormItem>
            </FormSection>
          )}
          {this.state.msaMode === 'msa' && (
            <FormSection>
            <div>
            <div>Selected MSAs{' '}<LinkText style={{"display": 'inline'}} onClick={this.onClearAllMSAs}>clear all MSAs</LinkText></div>
              {this.state.allowedMSAs &&
                this.state.allowedMSAs.map(item => (
                  <Tag key={item._id} closable afterClose={() => this.onRemoveMSA(item)}>
                    {item.msaName}
                  </Tag>
                ))}
            </div>
            </FormSection>
          )}
        {this.state.msaMode === 'state' && (
          <FormItem>
          <div>Selected States{' '}<LinkText style={{"display": 'inline'}} onClick={this.onClearAllStates}>clear all States</LinkText></div>
            <FormItem>{this.state.allowedStates && this.state.allowedStates.map(item => `${item}, `)}</FormItem>
          </FormItem>
        )}
        <FormSection>
          {this.state.msaMode === 'msa' && (
            <div>
              <FormItem label="Add MSAs by the MSA">
                <MsaSearchInput
                  onChange={value => this.setState({ allowedMSAs: this.uniqEs6([value, ...this.state.allowedMSAs] )})}
                />
              </FormItem>
            </div>
          )}
          {this.state.msaMode === 'state' && (
            <div>
              <FormItem label="Add MSAs by the State">
                <StatesInput onChange={this.onHandleStatesChange} />
              </FormItem>
            </div>
          )}
        </FormSection>
        <FormItem>
          <Button onClick={this.onSubmit}>{this.props.buttonLabel}</Button>
        </FormItem>
      </Form>
    );
  }
}

MsaForm.defaultProps = {
  buttonLabel: 'Save Changes',
  msaMode: 'msa',
  allowedMSAs: [],
  allowedStates: [],
};

export default compose(graphql(editMsas, { name: 'editMsas' }))(MsaForm);



// WEBPACK FOOTER //
// ./src/components/forms/MsaForm/index.js